import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "surface-50"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLayout = _resolveComponent("HeaderLayout")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FooterLayout = _resolveComponent("FooterLayout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($data.store.token != '' && $data.store.token != undefined)
      ? (_openBlock(), _createBlock(_component_HeaderLayout, { key: 0 }))
      : _createCommentVNode("", true),
    ($data.store.token == '' || $data.store.token == undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_view)
        ]))
      : _createCommentVNode("", true),
    ($data.store.token != '' && $data.store.token != undefined)
      ? (_openBlock(), _createBlock(_component_FooterLayout, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}